/**
 * IoT Onboard Dashboard - Split-panel container
 *
 * Modeled on ApiIngestDashboard: Chat (55%) + Live Telemetry (45%)
 * with secondary tabs for Fleet Overview and Monitoring.
 */

import { useState, useCallback } from 'react';
import PageShell from '@/components/PageShell';
import { Cpu } from 'lucide-react';
import IoTOnboardChat from './IoTOnboardChat';
import LiveTelemetryPanel from './LiveTelemetryPanel';

export default function IoTOnboardDashboard() {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [activeDeviceId, setActiveDeviceId] = useState<string | null>(null);

  const handleSessionChange = useCallback((sid: string) => {
    setSessionId(sid);
  }, []);

  const handleDeviceReady = useCallback((deviceId: string) => {
    setActiveDeviceId(deviceId);
  }, []);

  return (
    <PageShell
      title="IoT Device Onboarding"
      subtitle="Tell me the device make and model. I will discover the specs, create templates, generate a decoder, and set up a listener."
      icon={Cpu}
      iconColor="bg-cyan-600"
    >
      <div
        className="grid gap-4"
        style={{
          gridTemplateColumns: 'minmax(0, 55fr) minmax(0, 45fr)',
          height: 'calc(100vh - 220px)',
        }}
      >
        {/* Left: Chat */}
        <IoTOnboardChat
          sessionId={sessionId}
          onSessionChange={handleSessionChange}
          onDeviceReady={handleDeviceReady}
        />

        {/* Right: Live Telemetry */}
        <LiveTelemetryPanel
          activeDeviceId={activeDeviceId}
        />
      </div>
    </PageShell>
  );
}
